import React from 'react';

export const ColumnWidthIndicator = ({ className = '' }) => {
  return (
    <div className={`flex items-center opacity-100 justify-center ${className}`} style={{ width: '30px', height: '30px' }}>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M13.332 12.668L2.66537 12.668M2.66537 3.33464L13.332 3.33464M10.6654 6.66797L5.33203 6.66797C4.96383 6.66797 4.66537 6.96644 4.66537 7.33464L4.66537 8.66797C4.66537 9.03617 4.96383 9.33464 5.33203 9.33464L10.6654 9.33464C11.0336 9.33464 11.332 9.03617 11.332 8.66797L11.332 7.33464C11.332 6.96644 11.0336 6.66797 10.6654 6.66797Z" stroke="#2B3674" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>

</svg>
    </div>
  );
};